import SolagroAPIClient from '../api/SolagroAPIClient';

const client = new SolagroAPIClient('/api');
client.authorizationToken = localStorage.getItem('authorizationToken');
if (!client.authorizationToken || client.authorizationToken === 'null') {
    client.authorizationToken = null;
}
export default client;
